import base from './base';
import boilerplate from './boilerplate';
import chiamarsiBomberTheme from './chiamarsi-bomber';
import defaultTheme from './default';
import fanaticsTheme from './fanatics';
import foxThemeLight from './fox';
import foxThemeDark from './fox-dark';
import jockeyClubTheme from './jockey-club';
import jockeyClubCheltenhamTheme from './jockey-club-cheltenham';
import joeTheme from './joe';
import laGazzettaDeloSport from './la-gazzetta-delo-sport';
import ocusTheme from './ocus';
import theSportingNewsTheme from './the-sporting-news';

const themes: Record<string, string> = {
  fox: foxThemeLight,
  'fox-dark': foxThemeDark,
  'jockey-club': jockeyClubTheme,
  'jockey-club-cheltenham': jockeyClubCheltenhamTheme,
  'jockey-club-web': jockeyClubTheme,
  'jockey-club-cheltenham-web': jockeyClubCheltenhamTheme,
  joe: joeTheme,
  'la-gazzetta-delo-sport': laGazzettaDeloSport,
  ocus: ocusTheme,
  'the-sporting-news': theSportingNewsTheme,
  'chiamarsi-bomber': chiamarsiBomberTheme,
  fanatics: fanaticsTheme
};

export default function (theme?: string): string {
  return `${boilerplate} ${base} ${theme ? (themes[theme] ?? defaultTheme) : defaultTheme}`;
}
